// extracted by mini-css-extract-plugin
module.exports = {"head":"gallaryoptions_head__1fNaO","active":"gallaryoptions_active__2QMcw"};